<div class="d-flex align-items-center justify-content-end text-white text-end h-100 py-2">
  <div class="points-bar bg-glass">
    <i class="material-icons">loyalty</i>
    <span class="fw-bold">{{ pointsBalance$ | async | FortressCurrencyPipe: 'PTS' }}</span>
  </div>
</div>
